import React, {useContext, useState, useEffect} from 'react'

import {DataContext} from '../../dataContext'
import getColorOverride from '../../utilities/functions'

import MajorityMeter from '../../utilities/MajorityMeter'
import LiveUpdates from '../../utilities/LiveUpdates';
import SeatMap from '../../utilities/SeatMap';
import { useParams } from 'react-router-dom';
import Declaration from '../../utilities/Declaration';

export default function App() {
    const {data} = useContext(DataContext)
	const [seats, setSeats] = useState([])
	const [parties, setParties] = useState([])
	const {results} = data;
	const [loaded, toggleLoaded] = useState(false)
	const [imgClass, setImgClass] = useState('fade-in-image')

	let candidates = 0

	const {prov, year} = useParams()

	useEffect(()=> {
		setTimeout(()=> {
			setImgClass('')
		}, 3000)
	}, [])

    useEffect(()=> {
        if (results.party) {
			let total = 0
			setSeats([])
			setParties([])
            results.party.partyResults.map((party, i)=>{
				for (let j=0; j<party.seats; j++) {
					total++
                    setSeats( oldArray=> [ ...oldArray, { party: party.nameShort,  id: j, color: party.color }])
				}
				if (i <=results.party.partyResults.length-1 && i >4) {
					if (!party.seats) {
						return;
					}
				}
				setParties(oldArray=>[...oldArray, {partyName: party.nameShort,id:i, seats: party.seats, color: party.color,votesPercent: party.votesPercent,votesTotal: party.votes}])
				
			})
			if (total < data.config.seats) {
				for (let k=0; k<data.config.seats-total; k++) {
					setSeats( oldArray=> [ ...oldArray, { party: 'none',  id: k, color: '#e0e0e0' }])
				}
			}
		}
	}, [results])

	const getLeaders = (partyName) => {
		if (data.leaders) {
			let leaderData = data.leaders.parties.find(party=>{
				return party.partyNameShort === partyName
			});
			return leaderData
		} else return null
	}

    const Party = (props) => {
		const {party, id} = props; 
		const leader = getLeaders(party.partyName)
		const colors = getColorOverride(party.partyName, `${prov}_${year}`) 
		return (
			// <div className={'classes.partyContainer relative basis-full flex flex-col flex-1 max-h-full self-end'} id="top-scrollbar">
				<>
				<div className={'classes.partyImgBox transition min-h-fit items-end flex overflow-hidden h-full relative max-w-[95%] mx-auto'} id="partyImg">
					{leader.imgName && 
						<img 
							id={`leaderImg-${leader.partyNameShort}`}
							style={{opacity: loaded ? 1 : 0}}
							role="img"
							className={`${loaded ? imgClass : 'hide'} text-xs m-auto max-h-full max-w-full z-50 h-auto w-auto object-contain hidden xs:block`}
							onLoad={()=>handleLoad()}
							onError={()=>handleLoad()}
							aria-hidden={true}
							src={`data/${prov}/headshots/${leader.imgName}`} 
							alt={`Leader for ${leader.partyName} headshot`}/>
						}
				</div>
				<div key={party.id} id="partyCard" className={'classes.partyChiclet justify-center self-stretch rounded p-1 sm:p-2 flex flex-col items-center text-center'} style={{backgroundColor: colors ? colors.color : party.color, color: colors ? colors.font: 'white'}}>
					<div id="leaderNames">
						<div id="partyName" className={'hidden sm:block font-semibold text-xs xs:text-base md:text-xl'}>{leader.partyName}</div>
						<div id="partyName" className={'block sm:hidden font-semibold text-xs xs:text-base md:text-xl'}>{leader.partyNameShort}</div>
						{leader.partyLeader?
							<div id="leaderName" className="hidden sm:block text-sm">{leader.partyLeader}</div>:
							<div id="leaderName" className="hidden sm:block  text-sm " style={{color: colors?colors.color: 'black'}}>{"."}</div>
						}
					</div>
					<div id="leaderSeats" aria-label={`${party.seats} seats won`} className={'classes.popVote text-base xs:text-3xl md:text-4xl'}> {party.seats} </div>
				</div>
			{/* </div> */}
			</>

		);
	}

	const handleLoad =() => {
		candidates++
		if (candidates === 4) {
			toggleLoaded(true)
		}
	}


    return (
        <div className={'classes.seatApp relative h-full'}>
			{(results.party && seats && parties) && 
			<div className={'classes.main flex flex-col max-h-[420px] h-leaderApp relative'}>
				<div className={'classes.titleRow flex justify-between items-center'} id="widgetTitleRow">
					<div className={'classes.left'}>
						<div id="widgetTitle" className={'classes.title text-lg xs:text-2xl sm:text-3xl font-bold'}>{data.config.title}</div>
					</div>
					{<div className={'classes.majorityMeter w-1/3 max-w-[130px] flex-shrink pt-6 pr-4'}>
						<MajorityMeter limit={true} seatTotal={data.config.total} majority={data.config.majority} majorityPercent={(data.config.majority/data.config.total)*100} data={results.party}/>
					</div>}
				</div>
				<div style={{gridTemplateColumns: `repeat(${parties.length}, 1fr)`, gridTemplateRows: 'auto max-content'}} className={'classes.partyMap grid content-evenly grid-flow-col gap-x-1 xs:gap-x2 overflow-y-hidden overflow-x-auto'}>
					{parties.sort((a,b)=>{
						if (a.seats > b.seats) {
							return -1
						} else if (a.seats < b.seats) {
							return 1
						} else return 0
					}).map((party, i)=>{
						return <Party key={party.id} party={party} id={i}/>
					})}
				</div>
				<div className='py-2'>
					<Declaration declaration={results.declaration} majority={data.config.majority} showLeading={true} />
				</div>
				<div className={'classes.seatContainer overflow-hidden relative flex-shrink max-h-16 h-full'}>
					<SeatMap seats={seats}/>
				</div>
				{data.config.election_day &&
					<LiveUpdates time={results.party.generated} />
				}
		    </div>}
			{/* {document.getElementById('leaderImg-CAQ') &&
				<div>{loaded.toString()} {(document.getElementById('leaderImg-CAQ').classList)}</div>
			} */}
        </div>
    )
}
